module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-8393510698584ed5f84aec67ee23b7ae.png";